import ReactDOM from 'react-dom';
import { useEffect, useState } from "react";
import app from "../components/app";

import {AppLink as Link, AppWrapper, AppBlocks, SelectPages} from "../components/helpers";
import Editor from "./editor";
import Preview from "./preview";



function isEmail(email) { 
    return /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(email);
} 

const openPopup = function(data, callback){
    const div = document.createElement("div");
    document.body.appendChild(div);
    ReactDOM.render(<SelectPages data={data} callback={callback} />, div);
}

export default function Users(props) {
    const [pages, setPages] = useState([]);
    const [data, setData] = useState(null);
    
    const [email, setEmail] = useState(null);
    useEffect(() => {
        app.loadConfig();
        if(localStorage.getItem("joinEmail")) {
            if(localStorage.getItem("joinEmail").indexOf("appypiellp.com") !== -1) {
                setEmail(localStorage.getItem("joinEmail"));
            }
        }
        if(props.page) {
            app.fetchBuilder({
                method:"getPage",
                id:props.page,
                email:localStorage.getItem("joinEmail")
            }).then(function(response){
                if(response) {
                    if(response.status) {
                        let tempData  = response.data;
                        tempData["id"] = props.page;
                        setData(tempData);
                    }
                }
                
            })
        }
        else {
            if(localStorage.getItem("joinEmail")) {
                if(localStorage.getItem("joinEmail").indexOf("appypiellp.com") !== -1) {
                    app.fetchBuilder({
                        method:"getPages",
                        email:localStorage.getItem("joinEmail")
                    }).then(function(response){
                        if(response.status) {
                            setPages(response.data);
                        }
                    });
                }
            }
        }
    }, [props.page]);

    const removePage = function(index) {
        app.fetchBuilder({
            method:"removePage",
            id:pages[index].id,
            email:localStorage.getItem("joinEmail")
        }).then(function(response){
            if(response.status) {
                alert(response.data);
                setPages(pages.filter(function(v, i){
                    if(i === index) {
                        return false;
                    }
                    return true;
                }));
            }
        })
    }

    const savePage = function(data, mode) {
        app.fetchBuilder({
          method:"savePage",
          id:props.page,
          data:{
            title:data.title,
            page:data.page,
            dynamicAIData:JSON.stringify(data.dynamicAIData),
            category:data.category,
            email:localStorage.getItem("joinEmail"),
          }
        }, mode).then(function(){
         
        })
    }

    const joinEmail = function() {  
        const email = document.querySelector("#email").value.trim();
        if(isEmail(email)) {
            if(email.indexOf("appypiellp.com") !== -1) {
                localStorage.setItem("joinEmail", email);
                setEmail(email);
            }
            else {
                alert("Please enter a valid email address");
            }
        }
        else {
            alert("Please enter a valid email address");
        }
    }
    const selectPage = function() {

    }
    if(email) {
        if(props.category) {
            if(props.category === "preview") {
                return <Preview type="pages" id={props.page} />
            }
            return <div className="w-100 p-2">No Preview Found</div>
        }
        else if(props.page) {
            if(data) {
                return <Editor data={data} id={props.page} type="pages" callback={savePage} />
            }
            return <div className="w-100 p-2">Loading</div>
        }
        
        return <div className="w-100 h-100 overflow-scroll">
        <div className="row p-5">
            {
                pages.map(function(v, i){
                    return <div className="col-6 col-md-3 mb-4">
                    <div className="card w-100 h-100 position-relative">
                    <img src="https://media.mediadirhub.com/images/image-1x1.png" style={{
                        backgroundImage:`url(https://mediadirhub.com/pages/${v.id}.png)`
                    }} className="card-img-top background-fit" alt={v.data.title} />
                    <div className="card-body">
                    <h5 className="card-title">{v.data.title}</h5>
                    </div>
                    <Link className="position-absolute w-100 h-100 start-0 top-0 cursor-pointer" href={`/${v.id}`}></Link>
                        <button className="btn btn-primary position-absolute m-3 end-0 top-0 cursor-pointer" onClick={() => removePage(i)}>X</button>
                    </div>
                    </div>
                })
            }
          
          <div className="col-3 mb-4">
            <div className="card w-100 h-100 position-relative">
            <div className="card-body d-flex align-items-center justify-content-center">
            <a className="btn btn-primary me-2">Add New Page</a>
                </div>
                <div className="position-absolute w-100 h-100 start-0 top-0 cursor-pointer" onClick={() => openPopup(null, selectPage)}></div>
            </div>
          </div>
        
        </div>
      </div>
    }

    

    

    return <div className="w-100 h-100 overflow-scroll">
        <div className="d-flex justify-content-center bg-light p-4 border border-2 rounded-3 shadow-lg" style={{ width:"400px", position:"absolute", top: "50%", left:"50%", 
    transform: "translate(-50%, -50%)"}}> 

<div className="input-group input-group-lg mb-0">
  <input type="text" className="form-control" id="email" placeholder="Join with email" />
  <button className="btn btn-primary" onClick={joinEmail}>join</button>
</div>
        
 
        </div>
   
    </div>
}